angular.module("leanlaw").directive("mobileNotice", ["$window", $window => {
  return {
    restrict: "E",
    template: require("./views/mobileNotice.html"),
    // transclude: true,
    // replace: true,
    link: function ($scope, element, attrs) {
      // Check if this is a phone
      const md = require("mobile-detect");
      const detected = new md(window.navigator.userAgent);
      $scope.isMobileBrowser = detected.mobile() && detected.phone() && !detected.tablet();
      $scope.isIgnored = false;

      // Time to wait before showing the message again
      // Default is 1 week (in ms)
      const messageInterval = 1000 * 60 * 60 * 24 * 7;

      // Load ignored state from localStorage
      if (window.localStorage) {
        const localStorage = window.localStorage;

        // Check if localStorage contains isMobileIgnored key
        if (localStorage.getItem("isMobileIgnored") === null) {
          // Set default value
          localStorage.setItem("isMobileIgnored", $scope.isIgnored);
        } else {
          // Load persistent value from local storage
          let imi = localStorage.getItem("isMobileIgnored");
          $scope.isIgnored = !(imi == null || parseInt(imi) < new Date().getTime() - messageInterval);
        }
      }
      $scope.ignore = function ignore() {
        $scope.isIgnored = true;
        if (window.localStorage) {
          const localStorage = window.localStorage;
          localStorage.setItem("isMobileIgnored", new Date().getTime());
        }
      };
    }
  };
}]);